"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputKeys = void 0;
// The const is used to reference the property name in CreateAadAppOutput. When renaming the properties in CreateAadAppOutput, you need to update the const as well.
exports.OutputKeys = {
    clientId: "clientId",
    objectId: "objectId",
    tenantId: "tenantId",
    authorityHost: "authorityHost",
    authority: "authority",
    clientSecret: "clientSecret",
};
//# sourceMappingURL=createAadAppOutput.js.map